import styled from 'styled-components';
import CodeComponent from 'UIComponents/elements/Code';
import { StyledTable } from './Table';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledCode = styled(CodeComponent).withConfig({
  displayName: "Code__StyledCode",
  componentId: "cp32rq-0"
})(["word-break:break-word;word-wrap:break-word;hyphens:none;", " &{word-break:normal;word-wrap:normal;}"], StyledTable);

/**
 * Used by tech writers via Markdown backticks (\`\`) or by using the `<code />`
 * HTML element directly
 *
 * Under the hood, this renders a standard `UIComponents` `Code` component
 * with added `word-break` styling. The `word-break` styling is removed
 * conditionally when the parent component is a StyledTable, as under the hood
 * the StyledTable renders a standard `UIComponents` `UITable` component which
 * responsively allows tables to scroll sideways. Given that the scroll
 * container exists here we do not need `word-break` and further do not want it
 * as it causes too many breaks in the word at mobile screen sizes.
 */
const Code = props => /*#__PURE__*/_jsx(StyledCode, Object.assign({}, props));
export default Code;